import { render, staticRenderFns } from "./RmrCombobox.vue?vue&type=template&id=53a70588&scoped=true&"
import script from "./RmrCombobox.vue?vue&type=script&lang=js&"
export * from "./RmrCombobox.vue?vue&type=script&lang=js&"
import style0 from "./RmrCombobox.vue?vue&type=style&index=0&id=53a70588&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a70588",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VCombobox})
